/**
 * A typed phone list as it should be sent: trimmed, blank rows dropped,
 * repeats removed (first one kept) and capped at `max`.
 */
export function cleanPhoneList(phones: string[], max?: number): string[] {
  const cleaned = Array.from(new Set(phones.map((phone) => phone.trim()).filter(Boolean)));
  return max === undefined ? cleaned : cleaned.slice(0, max);
}

/** Row indexes whose number already appears in an earlier row. */
export function duplicatePhoneIndexes(phones: string[]): Set<number> {
  const seen = new Set<string>();
  const duplicates = new Set<number>();
  phones.forEach((phone, index) => {
    const value = phone.trim();
    if (!value) return;
    if (seen.has(value)) duplicates.add(index);
    seen.add(value);
  });
  return duplicates;
}
